/**
 * Created by mark on 10/01/2018.
 */



import React from 'react';
import {Button , FormControl , FormGroup ,  Navbar , NavDropdown , MenuItem , Nav , NavItem , Modal , Row , Col} from 'react-bootstrap';
import Card from './card.js';
import SearchService from '../services/search-service.js';
import Recorder from 'react-recorder'
import ContentService from '../services/content-service.js';
import $ from 'jquery';
import ContentStore from '../store/content-store.js';
import { FormattedMessage } from 'react-intl';

function isDataUrl(s){
    let regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;

    return !!s.match(regex);
}


export default class RecorderUpload extends React.Component {

    constructor(props){
        super(props);
        this.props = props;
        this.state = {command:'stop' , recording:false , audioPreview:null }
    }

    componentWillReceiveProps(props){

        this.setState({
            audioPreview: props.audioPreview || null
        });
    }

    onStop(blob){

        let reader = new FileReader();
        let file   = blob;

        reader.onloadend = () => {
            this.setState({
                file: file,
                audioPreview: reader.result
            });

            this.props.onChange(reader.result);
        };

        reader.readAsDataURL(file)
    }

    onStart(){
        console.log('start')
    }



    handelPreviewPlay(src){
        this.audio = new Audio(src);
        this.audio.play();
    }

    toggleRecording(){

        let recording = !this.state.recording;
        this.setState({
            command : recording ? 'start' : 'stop',
            recording : recording
        });
    }

    render(){

        return <div>
            <Button width={150} bsSize='small' disabled={!this.state.audioPreview} onClick={this.handelPreviewPlay.bind(this , this.state.audioPreview)} bsStyle="default" block><i className="zmdi-hc-1x zmdi zmdi-volume-up mdc-text-green"></i>&nbsp;<FormattedMessage id={"ui-2222"} defaultMessage={"Content Libary"} /></Button>

            <Button width={150}  bsSize='small'  className={this.state.recording ? "" : "" } onClick={this.toggleRecording.bind(this)} bsStyle={this.state.recording ? "danger" : "default"} block>
                <i className={"zmdi-hc-1x zmdi "+ ( this.state.recording ? "mdc-text-white zmdi-stop animated infinite pulse" :"zmdi-mic")}></i>&nbsp;{this.state.recording ? <FormattedMessage id={"ui-2223"} defaultMessage={"Record"} /> : <FormattedMessage id={"ui-2221"} defaultMessage={"Record"} />}
            </Button>

            <Recorder command={this.state.command} onStart={this.onStart.bind(this)}  onStop={this.onStop.bind(this)} />
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/components/recorderUpload.js